import { useCallback, useState } from "react";

export default function useRefCallback() {
	const [ref, setRef] = useState<HTMLDivElement | null>(null);
	const refCallback = useCallback(node => {
		node !== null ? setRef(node) : setRef(null);
	}, []);
	return [ref, refCallback] as const;
}
